import { render } from "./PartyasInformation.vue?vue&type=template&id=34c58b92&scoped=true"
import script from "./PartyasInformation.vue?vue&type=script&lang=js"
export * from "./PartyasInformation.vue?vue&type=script&lang=js"

import "./PartyasInformation.vue?vue&type=style&index=0&id=34c58b92&scoped=true&lang=css"

import exportComponent from "/Users/admin/Desktop/bos-vue/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c58b92"]])

export default __exports__